import CustomerItem from './CustomerItem';

export default CustomerItem;
